/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsCostListRequest {
    getFixupPrototypeFunction() { return AIUnitEconomicsCostListRequest.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsCostListRequest>): AIUnitEconomicsCostListRequest {
        let obj = Object.assign(new AIUnitEconomicsCostListRequest(), model);
        AIUnitEconomicsCostListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsCostListRequest>): AIUnitEconomicsCostListRequest {
        if (!model) return null;
        return AIUnitEconomicsCostListRequest.newInstance(<AIUnitEconomicsCostListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsCostListRequest) {
        if (!obj) return;

        models.AIUnitEconomicsCostListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsCostListRequest): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsCostListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AIUnitEconomicsCostFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AIUnitEconomicsCostSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AIUnitEconomicsCostSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AIUnitEconomicsCostFilter;

}
